// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./ad_scroll_forward.png");
var dir = previousRequest.replace("ad_scroll_forward.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "ad_scroll_forward.png",
	name: "ad_scroll_forward",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/ad_scroll_forward.png
// module id = 974
// module chunks = 4